import { render, staticRenderFns } from "./imageLinkBlock.vue?vue&type=template&id=aab0dda0&scoped=true"
import script from "./imageLinkBlock.vue?vue&type=script&lang=js"
export * from "./imageLinkBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab0dda0",
  null
  
)

export default component.exports